// 客户账单管理

import { HttpQueryCustomerList } from '@/service/billing';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData:{
                page:1,
                rows:10,
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            // Plugins: {show: true},
        };
    },
    // created() {
    //     console.log(this.$route)
    //     if(this.$route.query.day){
    //         this.$set(this.formData,'EQ_billingDate',this.$route.query.day)
    //         this.formData.EQ_billingDate = this.$route.query.day
    //     }
    // },
    methods: {
        ajaxRequest: HttpQueryCustomerList,
        // interceptRequest(params){
        //     console.log(this.$route)
        //     const search = params.search
            
        //     if(this.$route.query.day){
                
        //     }else{
        //         return
        //     }
        // },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'query':
                    var url = this.$router.resolve({
                        name: "billsManageDetail",
                        params: { type: "query" },
                        query: { id: params, detailtype: 'customer' },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/bill/export", this.formData,
                        "download"
                    );
                    break;
                case 'exportdetail':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/billDetail/export", { billId: params }, { executor: 'request', download: true }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, type } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getWarehouseList', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
                {
                    name: "导出明细",
                    operate: "exportdetail",
                    theme: "success",
                    batch: true,
                },
            ]
        },
        SearchsData() {
            return [
                // {
                //     label: "仓库",
                //     key: 'EQ_orgWarehouseId',
                //     show: true,
                //     tag: 'vSelect',
                //     options: this.getWarehouseList,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: "账单编号",
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "创建时间",
                    key: 'BT_createdAt',
                    show: true,
                    tag: 'vDatepicker',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },
                {
                    label: "月份",
                    key: 'EQ_billingDate',
                    more: true,
                    tag: 'vDatepicker',
                    default:this.$route.query.day,
                    props: {
                        format: 'yy-mm',
                        confirm: false,
                    },
                },

                {
                    label: "项目",
                    key: 'EQ_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                //  {
                //     title: '仓库',
                //     key: 'orgWarehouseCode',
                // },
                 {
                    title: '账单编号',
                    // key: 'billNo',
                    render: (h, { row }) => {
                        return <div><a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.billNo}</a></div>
                    }
                }, {
                    title: '项目',
                    // key: 'lineName',
                    render:(h,{row})=>{
                        return <div>{this.findRenderLabel(this.getCusproductList, row.lineId) || '--'}</div>
                    }
                }, {
                    title: '状态',
                    key: 'billStatus',
                    render: (h, { row }) => {
                        return row.billStatus == 1 ? '已确认' : '已创建'
                    }
                }, {
                    title: '月份',
                    key: 'billingDate',
                }, {
                    title: '总费用',
                    key: 'totalCost',
                },
                {
                    title: '币种',
                    key: 'currency',
                },
                {
                    title: '更新时间',
                    key: 'createdAt',

                }];
        },
    },
};




